import React, { useRef, useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './style/Navbar.css';

function NavBar() {

  const navRef = useRef(null);
  const dropdownRef = useRef(null);
  const [isNavOpen, setIsNavOpen] = useState(false);

  function toggleNav() {
    if (navRef.current) {
      setIsNavOpen(!isNavOpen);
    }
    const navLinks = document.querySelector('.nav-links');
    const dropdown = document.querySelector('.navbar-toggler');
    if (!isNavOpen) {
      // Create dropdown menu
      const dropdownMenu = document.createElement('ul');
      dropdownMenu.classList.add('dropdown-menu');
    
      // Add each navigation link to the dropdown menu
      navLinks.querySelectorAll('li').forEach((link) => {
        const dropdownItem = document.createElement('li');
        dropdownItem.classList.add('dropdown-item');
        dropdownItem.appendChild(link.cloneNode(true));
        dropdownMenu.appendChild(dropdownItem);
      });
      // Append the dropdown menu to the dropdown container
      dropdown.appendChild(dropdownMenu);
    } else {
      // Remove the dropdown menu if it exists
      if (dropdown != null) {
        const dropdownMenu = dropdown.querySelector('.dropdown-menu');
        if (dropdownMenu) {
          dropdown.removeChild(dropdownMenu);
        }
      }
    }
  }
  
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        console.log("hi");
        const dropdown = document.querySelector('.navbar-toggler');
        if (dropdown != null) {
          const dropdownMenu = dropdown.querySelector('.dropdown-menu');
          if (dropdownMenu) {
            dropdown.removeChild(dropdownMenu);
          }
        }
      }
    };

    window.addEventListener('click', handleOutsideClick);

    return () => {
      window.removeEventListener('click', handleOutsideClick);
    };
  }, [dropdownRef]);


  return (
    <nav className="navbar">
      <div className="navbar__logo">
        <NavLink to="/" className="navbar__logo-link">
          My Portfolio
        </NavLink>
      </div>
      
      <div class="dropdown" ref={dropdownRef}>
        <button className="navbar-toggler" id="navbar-toggler" type="button" onClick={toggleNav}>
          <img src="https://www.citypng.com/public/uploads/small/31634946136ladzeji1gfh7vjajgmykpzjzuy9tv05vhxhgf45np7nyqtrbba7t1iqdbl06ba6y04fqsxnqxua4psvza3obbruuqaanolk3d4lz.png" style={{ width: "40px", height: "40px" }}/>
        </button>
      </div>

      <div class="nav-links" id="nav-links" ref={navRef}>
        <ul className="navbar__links">
          <li>
            <NavLink to="/" activeClassName="active" className="navbar__link">
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/about" activeClassName="active" className="navbar__link">
              About
            </NavLink>
          </li>
          <li>
            <NavLink to="/projects" activeClassName="active" className="navbar__link">
              Projects
            </NavLink>
          </li>
          <li>
            <NavLink to="/WorkExperience" activeClassName="active" className="navbar__link">
              Experience
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default NavBar;
